var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('access-suspension-overlay'),_c('upgrade-modal',{attrs:{"is-visible":_vm.isUpgradeModalVisible},on:{"close":_vm.closeUpgradeModal}}),_c('localization')],1)}
var staticRenderFns = []

export { render, staticRenderFns }